'use client';
import React from 'react';

import Link from 'next/link';
import { useLocale, useTranslations } from 'next-intl';
import styled from 'styled-components';

import { LOCALES } from '@/i18n';
import Button from '@/ui/components/Button';
import Flags from '@/ui/components/Flags';
import Heading from '@/ui/components/Heading';
import SearchInput from '@/ui/components/SearchInput';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 45.625rem;
  margin: auto;
  padding: 3.75rem 0rem 0 0rem;
  justify-content: center;
  align-items: center;
  gap: 1.25rem;

  ${({ theme }) => theme.breakpoints.down('md')} {
    display: none;
  }

  h3 {
    margin-bottom: 0;
  }
`;

const Paragraph = styled.div`
  display: flex;
  width: 37.5rem;
  justify-content: center;
  align-items: center;
  gap: 3.75rem;

  button {
    flex-shrink: 0;
  }
`;

const ContentBellowSearch = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  justify-content: start;
`;

type FlagItem = {
  locale: string;
  link: string;
};

/**
 * @todo use translations_info
 */
export default function StillNeedHelp() {
  const [flagItems, setFlagItems] = React.useState<FlagItem[]>([]);
  const currentLocale = useLocale();
  const translate = useTranslations();

  React.useEffect(() => {
    const flagItems = LOCALES.filter(locale => locale !== currentLocale).map(locale => {
      const path = window.location.pathname;

      // Remove current locale from the beginning of the path using regex
      const pathWithoutLocale = path.replace(new RegExp(`^/${currentLocale}`), '');

      return {
        locale,
        link: `/${locale}${pathWithoutLocale}`,
      };
    });

    setFlagItems(flagItems);
  }, [currentLocale, typeof window !== 'undefined' && window.location.pathname]);

  return (
    <Wrapper>
      <Heading headingSize="h2" headingComponent="h2">
        {translate('app-containers-StillNeedHelp-title')}
      </Heading>
      <SearchInput
        placeholder={translate('app-containers-StillNeedHelp-searchField-placeholder')}
        locale={currentLocale}
      />
      <ContentBellowSearch>
        <Heading headingSize="h4" headingComponent="h3">
          {translate('app-containers-StillNeedHelp-subtitle')}
        </Heading>
        <Paragraph>
          <div>
            {translate.rich('app-containers-StillNeedHelp-paragraph', {
              link: chunks => <Link href="/">{chunks}</Link>,
            })}
          </div>
          <Button label="Contact us" />
        </Paragraph>
        <Flags items={flagItems} />
      </ContentBellowSearch>
    </Wrapper>
  );
}
